<template>
  <div class="dashboard__roadmap">
    <p class="dashboard__roadmap--title" style="padding-bottom: 15px; border-bottom: 1px solid #E8EBEE">Shipments Road Maps</p>
    <div class="w-100 pt-2 worldmap" style="height: 400px;">
      <vue-world-map id="worldmap" 
      v-bind:countryData="dataCountry"
      v-bind:defaultCountryFillColor="map.defaultCountryFillColor"
      v-bind:highColor="map.highColor"
      v-bind:countryStrokeColor="map.countryStrokeColor"
      v-bind:lowColor="map.lowColor"></vue-world-map>
    </div>
    <div v-if="isLoading"
        class="spinner__medium--blue d-flex justify-content-center">
      <half-circle-spinner
        :animation-duration="1500"
        :size="50"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div class="dashboard__roadmap--data" v-else-if="dataRoadMap && dataRoadMap.length > 0">
      <div class="row m-0 label global__bc_blue p-3" style="color: #fff;">
        <div class="col-md-4 br-right pl-0 pb-2">Shipment Type</div>
        <div class="col-md-7 pr-0 pb-2">Destination</div>
        <div class="col-md pr-0 pb-2">Action</div>
      </div>
      <div class="row m-0 list br-bottom" v-for="(item, i) in dataRoadMap" :key="i" style="border: 1px solid #E8EBEE">
        <div class="col-md br-right pl-0 py-2 ml-3">
          <p>{{getShipmentType(item.shipment_type)}}</p>
        </div>
        <div class="col-md-8 pr-0 py-2" >
          <div class="row m-0">
            <div class="col-md p-0 d-flex align-items-start">
              <div class="row m-0 text-center" :id="`route-${i}`">
                <p>{{item.origin_city_code}} ({{item.origin_city}})</p>
                <p class="px-3">-</p>
                <p>{{item.destination_city_code}} ({{item.destination_city}})</p>
              </div>
               <b-tooltip id="route-road-map" :target="`route-${i}`" placement="bottomright" class="text-center">
                <p>{{item.origin_city_code}} ({{item.origin_city}}) - [{{item.destination_city_code}}]</p>
                <b>{{item.origin_city}} to {{item.destination_city}}</b>
              </b-tooltip>
            </div>
            <!-- <button class="button__whiteroundsmall mr-4"
              @click.prevent="getRFQbyId(item.id_rfq, item.shipment_type)">
              <span v-if="isLoadingItemRfq"
                    class="spinner__small--white">
                  <b-spinner label="Loading..."></b-spinner>
              </span>
              <span v-else>Reorder</span>
            </button> -->
            <div class="d-flex mr-4" style="cursor: pointer;" @click.prevent="getRFQbyId(item.id_rfq, item.shipment_type)">
              <img src="@/assets/image/icon/Reorder.svg" alt="">
              <p>Reorder</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 dashboard__roadmap--emptydata" v-else>
      <div class="row m-0 label global__bc_blue p-3" style="color: #fff;">
        <div class="col-md-4 br-right pl-0 pb-2">Shipment Type</div>
        <div class="col-md-7 pr-0 pb-2">Destination</div>
        <div class="col-md pr-0 pb-2">Action</div>
      </div>
      <div class="align-item-center m-0 list br-bottom" style="border: 1px solid #E8EBEE; height: 120px;" >
        <p class="mt-5" style="color:#D2D6DD; font-weight: 700; font-size:12px;">You have never had a shipment. Create shipment now!</p>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
import VueWorldMap from 'vue-world-map'

export default {
  name: 'RoadMap',
  props: {
    dataRoadMap: Array,
    isLoading: Boolean,
    dataCountry: Object
  },
  components: {
    HalfCircleSpinner,
    VueWorldMap
  },
  computed: {
    ...mapGetters({
      itemRfq: 'rfq/item', // rfq by id
      isLoadingItemRfq: 'rfq/isLoading',

      getRoadmapCountry: 'dashboard/getRoadmapCountry',
      errorGetRoadmapCountry: 'dashboard/errorGetRoadmapCountry',
      isLoadingGetRoadmapCountry: 'dashboard/isLoadingGetRoadmapCountry'
    })
  },
  data () {
    return {
      service: {
        origin: '',
        destination: ''
      },
      map: {
        countryData: {
          ID: 10,
          SG: 2,
          JP: 111
        },
        defaultCountryFillColor: 'rgba(29, 51, 84, 0.1)',
        highColor: 'rgba(29, 51, 84, 1)',
        lowColor: 'rgba(29, 51, 84, 1)',
        countryStrokeColor: 'white'
      }
    }
  },
  methods: {
    getShipmentType (type) {
      if (type === 'AIRCARGO') {
        return 'Air Cargo'
      } else if (type === 'AIRCOURIER') {
        return 'Air Courier'
      } else {
        return type.split('SEA').join('')
      }
    },
    modifyShipmentService (type) {
      if (type === 'ptp') {
        this.service.origin = 'Port'
        this.service.destination = 'Port'
      } else if (type === 'dtp') {
        this.service.origin = 'Door'
        this.service.destination = 'Port'
      } else if (type === 'ptd') {
        this.service.origin = 'Port'
        this.service.destination = 'Door'
      } else if (type === 'dtd') {
        this.service.origin = 'Door'
        this.service.destination = 'Door'
      }
    },
    async getRFQbyId (idRFQ, type) {
      // ntar ini diubah minta tambain shipment service di BE
      await this.$store.dispatch('rfq/FETCH_RFQ_BY_ID', idRFQ)
      const typeShipment = 'type-shipment'
      let typeMode = ''
      return new Promise((resolve) => {
        if (this.itemRfq) {
          this.modifyShipmentService(this.itemRfq.optiontp)
          if (type && type.includes('SEA')) {
            typeMode = 'OCEAN'
          } else if (type && type.includes('AIR')) {
            typeMode = 'AIR'
          }
          this.$router.push({
            name: 'RequestShipment',
            params: {
              type: 'rfq',
              id: idRFQ,
              step: typeShipment
            },
            query: {
              mode: typeMode,
              ori: this.service.origin,
              des: this.service.destination
            }
          })
        }
        return resolve()
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/dashboard/RoadMap.vue